import { render, staticRenderFns } from "./ItemName.vue?vue&type=template&id=a25848e0&"
import script from "./ItemName.vue?vue&type=script&lang=js&"
export * from "./ItemName.vue?vue&type=script&lang=js&"
import style0 from "./ItemName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports